// extracted by mini-css-extract-plugin
export default {"beach-ball":"_5D1dnXG7","beach-ball__balloon":"_5D2zaY_b","is-filled":"_5D244x9P"};